import { apiService } from './index';

// Inport types
import { ISelectType } from '../shared/types/select-type';

export const asyncGetCities = async (
    department: string
): Promise<ISelectType[]> => {
    const { items }: any = await apiService.get(
        `/api/city/by-department/${department}`
    );
    return items || [];
};
